import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  careers: [],
  majors: [],
  minors: [],
  industries: [],
  careerResults: [],
  programResults: [],
  currentFacet: 'all',
  substreams: [],
  selectedStreamUuid: '',
  lastUpdatedTime: '',
  selectedMajor: '',
  selectedMinor: '',
  selectedIndustry: '',
  selectedCareer: '',
  bookmarks: [],
  programGuideFacetResults: [],
  programGuideSearchResults: [],
  programGuideSearchTerms: '',
  programGuideSearchSort: {},
  programGuideSearchFilter: {},
  programGuideSearchSelectedFacetNames: [],
  programGuideSearchCustomIncomeMin: '',
  programGuideSearchCustomIncomeMax: '',
  careerFacetResults: [],
  careerSearchResults: [],
  careerSearchTerms: '',
  careerSearchSort: {},
  careerSearchFilter: {},
  careerSearchSelectedFacetNames: [],
  careerSearchCustomIncomeMin: '',
  careerSearchCustomIncomeMax: '',
  programTotal: 0,
  careerTotal: 0,
  programScrollLeft: 0,
  programScrollTop: 0,
  careerScrollLeft: 0,
  careerScrollTop: 0,
  institutionCareers: [],
  careerSearchInstitutionCareerFilter: true
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/explore/vuex/index.js